var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellMoreManageLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m504.5 275.299-120.5-69.57c-4.642-2.68-10.358-2.68-15 0l-120.5 69.569c-4.641 2.68-7.5 7.631-7.5 12.99v139.142c0 5.359 2.859 10.311 7.5 12.99l120.5 69.57c4.642 2.68 10.358 2.68 15 0l120.5-69.569c4.641-2.68 7.5-7.631 7.5-12.99v-139.142c0-5.359-2.859-10.31-7.5-12.99z",
    fill: "#21affa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.5 357.861v154.139c2.59 0 5.179-.67 7.5-2.01l120.5-69.569c4.641-2.68 7.5-7.631 7.5-12.99v-139.142c0-2.68-.715-5.257-2.009-7.5z",
    fill: "#3083e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.5 203.72c-2.59 0-5.179.67-7.5 2.01l-120.5 69.569c-2.321 1.34-4.196 3.248-5.491 5.491l133.491 77.071z",
    fill: "#11d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.8 191.733v-112.466c0-8.284-6.716-15-15-15h-92.32l6.527-6.527c5.858-5.857 5.858-15.355 0-21.213s-15.355-5.858-21.213 0l-32.134 32.133c-2.929 2.929-4.394 6.768-4.394 10.606s1.464 7.678 4.394 10.606l32.133 32.133c5.858 5.858 15.355 5.858 21.213 0 5.858-5.857 5.858-15.355 0-21.213l-6.527-6.527h77.32v97.467c0 8.284 6.716 15 15 15s15.001-6.714 15.001-14.999z",
    fill: "#0b3c49"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    fill: "#ffb41b",
    r: 135.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 0c74.715 0 135.5 60.785 135.5 135.5s-60.785 135.5-135.5 135.5z",
    fill: "#ff9129"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    fill: "#ffd70e",
    r: 105.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 241c58.173 0 105.5-47.327 105.5-105.5s-47.327-105.5-105.5-105.5z",
    fill: "#ffb41b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.633 155.583c0-20.019-23.581-27.753-42.192-34.247-6.704-2.339-17.327-6.044-21.816-8.892 1.411-8.036 8.441-14.162 16.875-14.162 4.578 0 8.878 1.781 12.109 5.016 5.855 5.861 15.352 5.867 21.213.012 5.861-5.854 5.867-15.352.012-21.213-5.239-5.245-11.502-9.09-18.334-11.375v-3.506c0-8.284-6.716-15-15-15s-15 6.716-15 15v3.528c-18.655 6.281-32.133 23.927-32.133 44.672 0 20.019 23.581 27.753 42.192 34.247 6.704 2.339 17.327 6.044 21.816 8.892-1.411 8.036-8.441 14.162-16.875 14.162-4.578 0-8.878-1.781-12.109-5.016-5.855-5.861-15.352-5.867-21.213-.012-5.861 5.854-5.867 15.352-.012 21.213 5.239 5.245 11.502 9.09 18.334 11.375v3.506c0 8.284 6.716 15 15 15s15-6.716 15-15v-3.528c18.655-6.281 32.133-23.926 32.133-44.672z",
    fill: "#ffb41b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff9129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.441 121.337c-1.489-.519-3.176-1.109-4.941-1.739v31.803c6.184 2.206 13.383 4.938 16.875 7.153-1.411 8.036-8.441 14.162-16.875 14.162v46.066c8.284 0 15-6.716 15-15v-3.528c18.655-6.281 32.133-23.927 32.133-44.672 0-20.017-23.58-27.751-42.192-34.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.609 103.299c5.855 5.861 15.352 5.867 21.213.012 5.861-5.854 5.867-15.352.012-21.213-5.239-5.245-11.502-9.09-18.334-11.375v-3.506c0-8.284-6.716-15-15-15v46.066c4.578 0 8.878 1.781 12.109 5.016z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m48.2 320.267v112.467c0 8.284 6.716 15 15 15h92.32l-6.527 6.527c-5.858 5.857-5.858 15.355 0 21.213s15.355 5.858 21.213 0l32.133-32.133c2.929-2.929 4.394-6.768 4.394-10.606s-1.464-7.678-4.394-10.606l-32.133-32.133c-5.858-5.858-15.355-5.858-21.213 0-5.858 5.857-5.858 15.355 0 21.213l6.527 6.527h-77.32v-97.467c0-8.284-6.716-15-15-15s-15 6.713-15 14.998z",
    fill: "#185e6e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellMoreManageLess);
export default __webpack_public_path__ + "static/media/sell-more-manage-less.6b8129dc0af5df1ba51e117c8daf233f.svg";
export { ForwardRef as ReactComponent };